import React from "react";
import { SectionHeader } from "./Rates";
import { EMI_STEPS } from "../mock";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const EasyEMI = () => {
  return (
    <section id="emi" className="relative py-24 grid-bg">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <SectionHeader eyebrow="Gold on EMI · Nagpur" title="Buy Gold on EMI — Pay at Your Pace" sub="Reserve your gold coin with just 45% downpayment and convert the rest into easy instalments — starting from just ₹30 a day." />

        <div className="grid lg:grid-cols-[280px_1fr] gap-8 items-center">
          <div className="border border-gold/25 bg-gradient-to-br from-gold/[0.08] to-transparent p-10 text-center">
            <div className="font-display gold-gradient-text text-7xl">₹30</div>
            <p className="font-ui text-[10px] tracking-[0.25em] uppercase text-gray-400 mt-2">Starting EMI · Per Day</p>
            <button onClick={() => scrollTo('#coins')} className="mt-6 border border-gold text-gold font-ui text-[11px] tracking-[0.2em] uppercase px-6 py-3 hover:bg-gold hover:text-ink transition-colors">Browse Coins</button>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            {EMI_STEPS.map((s) => (
              <div key={s.n} className="relative border border-white/8 bg-white/[0.02] p-6 card-glow flex items-start gap-4">
                <div className="h-10 w-10 shrink-0 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center font-display text-xl text-gold">{s.n}</div>
                <div>
                  <h3 className="font-display text-xl text-white">{s.title}</h3>
                  <p className="font-body text-gray-400 mt-1">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EasyEMI;
